// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Polls/components/index.css
// module id = 880
// module chunks = 0